<template>
    <div class="modal" @click.prevent="$emit('closeModal')">
        <div class="modal-content" @click.stop>
            <i class="fa fa-remove" @click.prevent="$emit('closeModal')"></i>
            <h4 class="text-center">
                <a v-if="recordingProcessing===true">
                    Recording Processing
                </a>
                <a v-else :href="link" target="_blank">Open Meeting <span v-if="hasRecording===true">Archive </span><i class="fa fa-share"></i></a>
            </h4>
            <div class="wrapper">
                <div>
                    <h4 class="text-center">Attending ({{attending.length}} / {{maxParticipants}})</h4>
                    <ul class="students">
                        <li v-for="(student,$index) in attending">
                            <div class="avatar">
                                <img v-if="student.user.avatar" :src="student.user.avatar">
                                <img v-else src="static/static/img/mentorship-avatar.jpg">

                            </div>
                            <div class="name">
                                <span>
                                    <span class="number">{{$index + 1}}. </span>{{student.user.firstName | trim}} {{student.user.lastName | trim}}</span>
                            </div>
                        </li>
                    </ul>
                </div>
                <div>
                    <h4 class="text-center">Waitlist ({{waitListed.length}})</h4>
                    <ul class="students">
                        <li v-for="(student, $index) in waitListed">
                            <div class="avatar">
                                <img v-if="student.user.avatar" :src="student.user.avatar">
                                <img v-else src="static/static/img/mentorship-avatar.jpg">
                            </div>
                            <div class="name">
                                <span>
                                    <span class="number">{{attending.length + $index + 1}}. </span>
                                    {{student.user.firstName}} {{student.user.lastName}}
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['participants','maxParticipants','link','hasRecording','recordingProcessing'],
    data() {
        return {
            attending: [],
            waitListed: [],
        }
    },
    components: {

    },
    mounted() {
        if (this.participants) {
            for (let student of this.participants) {
                if (student.waitListed === true) {
                    this.waitListed.push(student);
                } else {
                    this.attending.push(student);
                }
                this.waitListed = this.waitListed.sort((a, b) => { return new Date(a.createdAt) - new Date(b.createdAt) });
                this.attending = this.attending.sort((a, b) => { return new Date(a.createdAt) - new Date(b.createdAt) });
            }
        }
    },
    methods: {

    },
    computed: {

    }
}

</script>
<style lang="scss" scoped>

.modal {
    display: flex;
    align-items:center;
    justify-content: center;
    background:rgba(0,0,0,.5);
}
.modal-content {
    padding:2rem;
    min-width:500px;
    max-height:70vh;
    overflow-y:auto;
    overflow-x: hidden;
}

.wrapper {
    display: flex;

    &>div {
        width: 50%;
    }
}

.fa-remove {
    position: absolute;
    top:5px;
    right:5px;
    font-size:1.4rem;
    cursor: pointer;
}

ul.students {
    text-align:center;
    li {
        margin-bottom: 1rem;
        padding:0 2rem;
        clear:both;
        display:flex;


    }
    .name {
        display:flex;
        justify-content: center;
        flex-direction: column;
        padding-left:1rem;
        white-space:nowrap;

    }

    .avatar {
        display:flex;
        align-items:center;
        .number {
            font-size:1.4rem;
        }
        img {
            border-radius: 50%;
            width: 50px!important;
            height: 50px!important;
            min-width:50px!important;
            object-fit: cover;
        }
    }
}
.modal-content {
    max-height:80vh;
    overflow-y: auto;
    scrollbar-width:none;
    &::-webkit-scrollbar { 
        display: none;
    }

}
</style>



// WEBPACK FOOTER //
// GlobalMeetingParticipants.vue?352ce56a